/* eslint-disable class-methods-use-this */
import http from '../httpService';

class AccountAuthService {
  async isTenantAvailable(input) {
    const result = await http.post(
      'api/services/app/Account/IsTenantAvailable',
      input
    );
    return result.data.result;
  }

  async register(input) {
    const result = await http.post('api/services/app/Account/Register', input);
    return result.data.result;
  }

  async updateUserInfo(input) {
    const result = await http.post(
      'api/services/app/Account/UpdateUserInfo',
      input
    );
    return result.data.result;
  }

  async sendPasswordResetCode(input) {
    const result = await http.post(
      'api/services/app/Account/SendPasswordResetCode',
      input
    );
    return result.data.result;
  }

  async resetPassword(input) {
    const result = await http.post(
      'api/services/app/Account/ResetPassword',
      input
    );
    return result.data.result;
  }

  async sendEmailActivationLink(input) {
    const result = await http.post(
      'api/services/app/Account/SendEmailActivationLink',
      input
    );
    return result.data.result;
  }

  async activateEmail(input) {
    const result = await http.post(
      'api/services/app/Account/ActivateEmail',
      input
    );
    return result.data.result;
  }

  async changePassword(input) {
    const result = await http.post(
      'api/services/app/Profile/ChangePassword',
      input
    );
    return result.data.result;
  }

  async isCurrentTenantAvailable() {
    const result = await http.post(
      'api/services/app/Account/IsCurrentTenantAvailable'
    );
    return result.data.result;
  }
}

export default AccountAuthService = new AccountAuthService();
